import { Controller } from "@hotwired/stimulus"

// Shows a hidden notice once the user edits one of the fields it is about,
// so a form can warn about the consequences of a change before it is saved
// without shouting the warning at everyone who merely opens the form.
//
// The watched fields are named by a CSS selector rather than as targets, so
// the kit's field components need no extra markup. Once shown, the notice
// stays: changing the value back does not make the consequence irrelevant
// enough to hide a checkbox the user may already have ticked.
export default class extends Controller {
  static targets = ["notice"]
  static values = { fields: String }

  reveal(event) {
    if (!this.hasNoticeTarget || !event.target.matches(this.fieldsValue)) return

    this.noticeTarget.hidden = false
  }
}
